import linkOut from "@ingka/ssr-icon/paths/link-out";
import SSRIcon from "@ingka/ssr-icon";
import { Buffer } from "buffer";
import Styles from "./AssemblyGuideProduct.module.scss";
import { useKiosk } from "../../../Hooks/useKiosk";
import { parseAssemblyArticleNum } from "../../../util/utils";

const AssemblyGuideProduct = ({
  product: { title, assemblyInstructions, link, id },
}) => {
  const isKiosk = useKiosk();
  return (
    <div className={Styles.assemblyGuideProduct}>
      <div className={Styles.assemblyGuideProduct__details}>
        <div className={Styles.assemblyGuideProduct__details__container}>
          <div
            className={Styles.assemblyGuideProduct__details__container__title}
          >
            {title}
          </div>
          <div className={Styles.assemblyGuideProduct__details__container__id}>
            <span>{parseAssemblyArticleNum(id)}</span>
          </div>
        </div>
        {!isKiosk && (assemblyInstructions || link) ? (
          <div className={Styles.assemblyGuideProduct__details__url}>
            <a
              href={assemblyInstructions || link}
              target="_blank"
              rel="noreferrer"
            >
              <SSRIcon paths={linkOut} colour="black" />
            </a>
          </div>
        ) : (
          ""
        )}
      </div>
      {isKiosk && (assemblyInstructions || link) ? (
        <div className={Styles.assemblyGuideProduct__qr}>
          <img
            alt=""
            src={`https://www.apidigitalappsiafg.net/qrcodegen/index.php/${Buffer.from(
              assemblyInstructions || link
            ).toString("base64")}`}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default AssemblyGuideProduct;
